import { createFileRoute } from "@tanstack/react-router";
import AdminVipCalendar from "@/pages/admin/AdminVipCalendar";

export const Route = createFileRoute("/admin/vip-calendar")({ component: AdminVipCalendar });
